module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_31.dot-8e674601ab87a9c61525516867d46402.svg";